import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/pages/home/index.vue')
    },
    {
      path: '/capacity-calculation',
      name: 'CapacityCalculation',
      component: () => import('@/pages/capacity-calculation/index.vue')
    },
    {
      path: '/twistedPair',
      name: 'twistedPair',
      component: () => import('@/pages/twistedPair/index.vue')
    },
    {
      path: '/bandwith',
      name: 'bandwith',
      component: () => import('@/pages/bandwith/index.vue')
    },
    {
      path: '/lens-calculation',
      name: 'LensCalculation',
      component: () => import('@/pages/lens-calculation/index.vue')
    },
    {
      path: '/nvr-selection',
      name: 'NvrSelection',
      component: () => import('@/pages/nvr-selection/index.vue')
    },
    {
      path: '/ip-calculation',
      name: 'IpCalculation',
      component: () => import('@/pages/ip-calculation/index.vue')
    },
    {
      path: '/RVV',
      name: 'RVV',
      component: () => import('@/pages/RVV/index.vue')
    },
    {
      path: '/ups-calculation',
      name: 'UpsCalculation',
      component: () => import('@/pages/ups-calculation/index.vue')
    },
    {
      path: '/cable-calculation',
      name: 'CableCalculation',
      component: () => import('@/pages/cable-calculation/index.vue')
    },
    {
      path: '/splicing-screen-calculation',
      name: 'SplicingScreenCalculation',
      component: () => import('@/pages/splicing-screen-calculation/index.vue')
    },
    {
      path: '/camera-power-calculation',
      name: 'CameraPowerCalculation',
      component: () => import('@/pages/camera-power-calculation/index.vue')
    },
    {
      path: '/switchAccessCalculator',
      name: 'switchAccessCalculator',
      component: () => import(`@/pages/switchAccessCalculator/index.vue`)
    },
    {
      path: '/intelligentWirelessSolution',
      name: 'intelligentWirelessSolution',
      component: () => import(`@/pages/intelligentWirelessSolution/index.vue`)
    },
    {
      path: '/solar-energy',
      name: 'solar-energy',
      component: () => import(`@/pages/solar-energy/index.vue`)
    },
  ]
})

//路由变化时，自动触发weui picker遮罩层的点击事件，将picker框关闭
router.beforeEach((to, from, next) => {
  let mask = document.getElementsByClassName('weui-mask')[0],
      pciker = document.getElementsByClassName('weui-picker')[0]
  if(mask && pciker) {
    let e = document.createEvent("MouseEvents")
    e.initEvent('click', true, true)
    mask.dispatchEvent(e)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js